import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../axios";

export default function UserPage() {
  const { userId } = useParams();
  const navigate   = useNavigate();
  const [user, setUser]       = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`/users/${userId}`)
      .then((res) => setUser(res.data))
      .catch((e) => {
        if (e.response?.status === 404) setNotFound(true);
      });
  }, [userId]);

  if (notFound) {
    return (
      <div style={S.page}>
        <div style={S.emptyBox}>
          <p style={{ color: "#6b7280" }}>ユーザーが見つかりません</p>
          <button style={S.backBtn} onClick={() => navigate(-1)}>← 戻る</button>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div style={S.page}>
        <div style={{ textAlign: "center", color: "#065f46", padding: "40px" }}>読み込み中...</div>
      </div>
    );
  }

  return (
    <div style={S.page}>
      <button style={S.backBtn} onClick={() => navigate(-1)}>← 戻る</button>

      {/* ユーザーヘッダー */}
      <div style={S.card}>
        <div style={S.avatar}>
          {user.name.charAt(0).toUpperCase()}
        </div>
        <h2 style={S.userName}>{user.name}</h2>
        <p style={S.meta}>登録: {user.joined_at}　総投稿数: {user.sightings_count} 件</p>

        {user.bio && (
          <p style={S.bio}>
            {user.bio.split('\n').map((line, i, arr) => (
              <React.Fragment key={i}>
                {line}
                {i < arr.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        )}

        {user.activity_area && (
          <div style={S.infoRow}>
            <span style={S.infoIcon}>📍</span>
            <span style={S.infoText}>{user.activity_area}</span>
          </div>
        )}
      </div>

      {/* SNS・リンク */}
      {(user.x_id || user.instagram_id || user.website_url) && (
        <div style={S.card}>
          <div style={S.cardTitle}>リンク</div>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {user.x_id && (
              <a
                href={`https://x.com/${user.x_id}`}
                target="_blank"
                rel="noreferrer"
                style={S.linkRow}
              >
                <span style={S.linkIcon}>𝕏</span>
                <span>@{user.x_id}</span>
              </a>
            )}
            {user.instagram_id && (
              <a
                href={`https://instagram.com/${user.instagram_id}`}
                target="_blank"
                rel="noreferrer"
                style={S.linkRow}
              >
                <span style={{ ...S.linkIcon, background: "linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)", color: "#fff" }}>
                  IG
                </span>
                <span>@{user.instagram_id}</span>
              </a>
            )}
            {user.website_url && (
              <a
                href={user.website_url}
                target="_blank"
                rel="noreferrer"
                style={S.linkRow}
              >
                <span style={{ ...S.linkIcon, background: "#e0f2fe", color: "#0369a1" }}>🔗</span>
                <span style={{ wordBreak: "break-all" }}>{user.website_url}</span>
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const S = {
  page: {
    minHeight: "100vh",
    padding: "16px",
    background: "linear-gradient(180deg, #ecfdf5 0%, #f0fdf4 100%)",
    fontFamily: "sans-serif",
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "20px",
    marginBottom: "16px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
    textAlign: "center",
  },
  cardTitle: {
    fontSize: "0.85rem",
    fontWeight: "700",
    color: "#047857",
    marginBottom: "14px",
    paddingBottom: "8px",
    borderBottom: "2px solid #d1fae5",
    textAlign: "left",
  },
  avatar: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #047857, #10b981)",
    color: "#fff",
    fontSize: "1.75rem",
    fontWeight: "700",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 12px",
  },
  userName: {
    fontSize: "1.2rem",
    fontWeight: "700",
    color: "#1f2937",
    margin: "0 0 4px",
  },
  meta: {
    fontSize: "0.78rem",
    color: "#9ca3af",
    margin: "0 0 12px",
  },
  bio: {
    fontSize: "0.88rem",
    color: "#374151",
    lineHeight: "1.7",
    margin: "0 0 12px",
    wordBreak: "break-word",
  },
  infoRow: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "0.85rem",
    color: "#6b7280",
  },
  infoIcon: { fontSize: "0.9rem" },
  infoText: { color: "#374151" },
  linkRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "0.88rem",
    color: "#047857",
    textDecoration: "none",
    padding: "6px 0",
  },
  linkIcon: {
    width: "28px",
    height: "28px",
    borderRadius: "6px",
    background: "#1f2937",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.75rem",
    fontWeight: "700",
    flexShrink: 0,
  },
  backBtn: {
    background: "none",
    border: "none",
    color: "#047857",
    fontSize: "0.85rem",
    cursor: "pointer",
    padding: "0 0 12px",
    display: "block",
  },
  emptyBox: {
    textAlign: "center",
    padding: "60px 16px",
  },
};
